import React from 'react';
import {getLoginUrl} from '../../shared/okta.helper'

export const unauthenticated = () => <h1 className="center-message"><span>Not Logged In.</span>&nbsp;
    <a id="MEDCAL_RX_CLICK_HERE" href={getLoginUrl()}>
        Click Here
    </a> <span>to Login.</span></h1>;

export const unauthorized = () => <h1 className="center-message">You are not authorized to view this application.</h1>;
